import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { AiReceptionistStats } from '../../models/AiReceptionist';

export interface AiReceptionistTotalsResponse {
  totals: AiReceptionistStats;
}

interface GetCompanyAiReceptionistTotalsPayload {
  company_id: string;
}

export async function getCompanyAiReceptionistTotals(
  payload: GetCompanyAiReceptionistTotalsPayload,
  auth: Authentication,
): Promise<AiReceptionistTotalsResponse> {
  try {
    if (!payload.company_id) {
      throw new GetCompanyAiReceptionistTotalsFailure('company_id est requis');
    }

    const response = await HttpClient.post('/company/ai-receptionist/totals', payload, auth.token);

    return response.data as AiReceptionistTotalsResponse;
  } catch (e) {
    console.error('getCompanyAiReceptionistTotals error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyAiReceptionistTotalsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyAiReceptionistTotalsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyAiReceptionistTotalsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
